import _ from "underscore";

import api from "@/helpers/api";
import auth from "@/helpers/auth";
import notifications from "@/helpers/notifications";
import realtime from "@/helpers/realtime";

const apiVersion = 'v1';
const source = 'conversations/webhooks';

export default {
  state: {
    all: [],
    current: null,
    hasMore: false,
    currentPage: 0
  },

  mutations: {
    addWebhooks(state, conversations) {
      const firstFetch = state.all.length === 0;

      const all = state.all;
      _.each(conversations, (convo) => {
        if (
          !_.find(all, (c) => {
            return c.id === convo.id;
          })
        )
          all.push(convo);
      });

      state.all = all;

      if (firstFetch) state.current = conversations[0];
    },

    prependWebhook(state, conversation) {
      const all = _.clone(state.all);
      all.unshift(conversation);

      state.all = all;

      notifications.notify(
        "Pending Webhook",
        {
          body: `${conversation.metadata.context.customer_name} | ${conversation.metadata.context.title}`,
          icon: conversation.metadata.context.image
        },
        (e) => {
          window.open("/webhooks", "_blank");
        }
      );
    },

    setCurrentWebhook(state, conversation) {
      state.current = conversation;
    },

    setHasMoreWebhooks(state, val) {
      state.hasMore = val;
    },

    clearWebhooks(state) {
      state.all = [];
      state.current = null;
      state.currentPage = 0;
      state.hasMore = false;
    },

    incrementWebhooksCurrentPage(state) {
      state.currentPage += 1;
    },

    updateWebhook(state, conversation) {
      state.all = _.map(state.all, (c) => {
        if (c.id !== conversation.id) return c;
        return conversation;
      });

      if (state.current && state.current.id === conversation.id) {
        state.current.webhook_status = conversation.webhook_status;
      }
    }
  },

  actions: {
    fetchWebhooks({ commit, dispatch, state }) {
      const params = {
        team_id: auth.teamId(),
        page: state.currentPage + 1
      };

      return api
        .instance()
        .get(`${apiVersion}/${source}`, { params })
        .then((resp) => {
          const convos = _.map(resp.data.data, (data) => data.attributes);
          commit("addWebhooks", convos);
          commit("incrementWebhooksCurrentPage");
          commit("setHasMoreWebhooks", resp.data.meta["total-pages"] > resp.data.meta["current-page"]);

          return convos;
        })
        .catch((err) => console.error("Failed to fetch webhooks", err));
    },

    changeCurrentWebhook({ commit, dispatch, state }, conversation) {
      commit("setCurrentWebhook", conversation);
    },

    setWebhookStatus({ commit, state }, status) {
      api
        .instance()
        .put(`${apiVersion}/${source}/${state.current.id}`, { webhook_status: status })
        .then((resp) => {
          // Pusher event will trigger status update
          return resp.data.data.attributes;
        })
        .catch((err) => console.error("Failed to update webhook", err));
    },

    connectRealtimeWebhooks({ commit, state }, teamId) {
      const channelName = `private-team-${teamId}`;

      realtime.subscribe(channelName, "webhook-pending", (data) => {
        const convo = data.data.attributes;
        console.log("Pusher: webhook-pending", convo);
        commit("prependWebhook", convo);
      });

      realtime.subscribe(channelName, "webhook-status-change", (data) => {
        const convo = data.data.attributes;
        console.log("Pusher: webhook-status-change", convo);
        commit("updateWebhook", convo);
      });
    }
  }
};
